import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	lastAdminErrorMessage: {
		id: 'users-and-roles.actors-table.role-cell.roles-picker-container.last-admin-error-message',
		defaultMessage:
			'This project needs at least one admin. Add another before changing your role or removing yourself.',
		description: 'Error message when you try removing the last admin from a project',
	},
	genericErrorTitle: {
		id: 'users-and-roles.actors-table.role-cell.roles-picker-container.generic-error-title',
		defaultMessage: 'Error',
		description: 'Error title when some action fails',
	},
	genericErrorMsg: {
		id: 'users-and-roles.actors-table.role-cell.roles-picker-container.generic-error-msg',
		defaultMessage: 'Something went wrong. Try again.',
		description: 'Generic error message when some error occurred during user action',
	},
});
